import React from 'react'
import "../Styles/Reviews.css"
import Rajasthan from "../Images/rajasthan_pic.png"

function Reviews() {
  return (
    <div>
      <div class="tripCard_wrapper">
        <div class="tripCard_image">
          <img src={Rajasthan} alt="Rajasthan Tour" />
        </div>
        <div class="tripCard_content">
          <h2 class="tripCard_title">Rajasthan Tour</h2>
          <p class="tripCard_date review_class">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Magnam facilis enim doloremque, nisi expedita consequatur architecto! Cum eum molestiae ut quos error, dolorem dolor! Quis quae consequatur tempora commodi nesciunt labore suscipit odio delectus voluptatibus ducimus mollitia, officiis inventore nemo provident! Eius beatae pariatur, ut nemo labore, reiciendis itaque laudantium tenetur quae illum quos. Est iure rem assumenda ab consequuntur ex at natus voluptatem, ipsam sit numquam alias eum consectetur totam porro aliquid id! Mollitia dolores, ut consequuntur consectetur et necessitatibus tempore, dolor facere suscipit ullam itaque sapiente modi explicabo, minus cumque asperiores consequatur aliquam animi earum tenetur at doloremque aut numquam? At ea molestias nisi reiciendis obcaecati laborum veritatis iste voluptatem qui sunt optio unde consectetur mollitia eius, quidem perspiciatis, dolores laboriosam accusantium commodi dicta rem voluptatibus nemo. Ex.</p>
          <div class="tripCard_buttons">
            {/* <button class="tripCard_btnDetails">Order details</button> */}
            <button class="tripCard_btnCancel">Delete</button>
          </div>
        </div>
      </div>


    </div>
  )
}

export default Reviews